import { parseDollarsToCents } from 'bench-internal-theme';

import ledgerAccountCategoryIds from './transaction-manager/ledgerAccountCategoryIds';

const reportKeyToLedgerAccountCategoryId = {
  totalAssets: ledgerAccountCategoryIds.ASSETS,
  totalLiabilities: ledgerAccountCategoryIds.LIABILITIES,
  totalEquity: ledgerAccountCategoryIds.EQUITY,
  totalRevenue: ledgerAccountCategoryIds.REVENUE,
  totalCogsExpense: ledgerAccountCategoryIds.COST_OF_SALES,
  totalOperatingExpense: ledgerAccountCategoryIds.OPERATING_EXPENSES,
};

const convertCategoryToLedgerSummaries = (amountKey, category, ledgerSummaryType) =>
  category.reduce(
    (collectedSummaries, [ledgerAccount, amountInDollars]) => [
      ...collectedSummaries,
      {
        ledgerAccount: {
          id: ledgerAccount.id,
          __typename: 'LedgerAccount',
        },
        [amountKey]: parseDollarsToCents(amountInDollars.toString()),
        __typename: ledgerSummaryType,
      },
    ],
    [],
  );

// eslint-disable-next-line import/prefer-default-export
export const makeReportTypePatcher =
  (ledgerSummaryType, ledgerCategorySummaryType, amountKey, reportDataKey) => data => {
    const ledgerSummaries = Object.values(data.categories).reduce(
      (summaries, category) => [
        ...summaries,
        ...convertCategoryToLedgerSummaries(amountKey, category, ledgerSummaryType),
      ],
      [],
    );

    const ledgerCategorySummaries = Object.keys(data).reduce((summaries, key) => {
      const ledgerAccountCategoryId = reportKeyToLedgerAccountCategoryId[key];
      if (ledgerAccountCategoryId) {
        return [
          ...summaries,
          {
            category: {
              id: ledgerAccountCategoryId,
              __typename: 'LedgerAccountCategory',
            },
            [amountKey]: parseDollarsToCents(data[key].toString()),
            __typename: ledgerCategorySummaryType,
          },
        ];
      }
      return summaries;
    }, []);
    return {
      [`${reportDataKey}LedgerSummaries`]: ledgerSummaries,
      [`${reportDataKey}CategorySummaries`]: ledgerCategorySummaries,
    };
  };
